import store from '@/store'
import WsSocket from '@/plugins/ws-socket'
import { Notification } from 'element-ui'
import Vue from 'vue'

// 引入消息处理类
import AssustantEvent from '@/im-server/event/assustant'
import LivechatEvent from '@/im-server/event/livechat'
import AuthEvent from '@/im-server/event/auth'
import NotifyEvent from '@/im-server/event/notify'


/**
 * SocketInstance 连接实例
 *
 * 注释: 所有 WebSocket 消息接收处理在此实例中处理
 */
const socket_url = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_SOCKET_URL : 'wss://' + window.location.host;

class SocketInstanceClass {
  /**
   * WsSocket 实例
   */
  socket

  /**
   * SocketInstance 初始化实例
   */
  constructor() {
    this.socket = new WsSocket(
      () => {
        let token = store.state.wsSocket.socketToken;
		if(token == ""){
			window.location.reload();
        }
		const { userId,brandIdentify } = store.state.user.userInfo;
		return `${socket_url}/websocket/livechat/agent/${brandIdentify}/${userId}?token=${store.state.wsSocket.socketToken}`
      },
      {
        onError: evt => {
          console.log('Websocket 连接失败回调方法')
		  store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
		  	type:`socket连接失败获取当前网络状态`,
		  	content:navigator.onLine
		  })
		  Vue.prototype.$api.getImServiceSocketToken(store.state.user.agentId,{redirect: 'follow',}).then(res => {
			  store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
			  	type:`socket连接失败重新请求token接口`,
				content:`响应：${JSON.stringify(res)}`
			  })
		  	if(res.errcode != 0) return;
		  	store.commit('wsSocket/UPDATE_SOCKET_TOKEM',encodeURIComponent(res.data))
		  	   
		  })
        },
        // Websocket 连接成功回调方法
        onOpen: evt => {
          // 更新 WebSocket 连接状态
          store.commit('wsSocket/UPDATE_SOCKET_STATUS', true);
		  store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
		  	type:`socket连接成功`,
		  })
		 if(store.state.permission.menus){
			 const index = store.state.permission.menus.findIndex((el) => el.menuName.indexOf('IM') != -1);
			 if(index != -1) {
				 store.dispatch('imChatService/load_talk_items');
			 }
		 }
		  
        },
        // Websocket 断开连接回调方法
        onClose: evt => {
          // 更新 WebSocket 连接状态
          store.commit('wsSocket/UPDATE_SOCKET_STATUS', false)
        },
      }
    )

    this.registerEvents()
  }

  // 连接 WebSocket 服务
  connect() {
    this.socket.connection()
  }
  //关闭socket
  close(){
  	this.socket.close()
  }

  /**
   * 注册回调消息处理事件
   */
  registerEvents() {
    this.socket.on('assistant', data => {
		new AssustantEvent(data).handle()
	})

    this.socket.on('livechat', data => {
      new LivechatEvent(data).handle()
    })

    this.socket.on('auth', data => {
      new AuthEvent(data).handle()
    })

    this.socket.on('msgcenter', data => {
      new NotifyEvent(data).handle()
    })
  }

  /**
   * 聊天发送数据
   *
   * @param {Object} mesage
   */
  send(mesage) {
    this.socket.send(mesage)
  }

  /**
   * 推送消息
   *
   * @param {String} event 事件名
   * @param {Object} data 数据
   */
  emit(event, data) {
    this.socket.emit(event, data)
  }
}

export default new SocketInstanceClass()
